<template>
	<div>
		<Clist :ShowFilas="false" :EmitSeccion="EmitSeccion" :regresar="false" @FiltrarC="Lista" :Filtro="Filtro" :Nombre="NameList" :isModal="EsModal" :Total="TotalPagina" :pConfigLoad="ConfigLoad">
			<template slot="Filtros">
				<div class="form-group mr-2">
					<label for="">Tipo de Servicio</label>
					<select @change="Lista();GetTipoSer();" v-model="Filtro.IdConfigS" name="" id="" class="ml-2 form-control">
						<option value="">- Tipo de Servicio -</option>
						<option value="1">Mantenimiento</option>
						<option value="2">Servicio</option>
						<option value="3">Proyecto</option>
					</select>
				</div>
				<div class="form-group mr-2">
					<label for="">SubTipo de Servicio</label>
					<select @change="Lista" name="" id="" class="ml-2 form-control" v-model="Filtro.IdTipoSer">
						<option value="">- SubTipo de Servicio -</option>
						<option :value="item.IdTipoSer" v-for="(item,index) in ListaTipoSer" :key="index">{{item.Concepto}}</option>
					</select>
				</div>
				<div class="form-group mr-2">
					<label>Año </label>
                    <select @change="Lista()"  v-model="Filtro.Anio" class="form-control ml-2">
                        <option v-for="(item,index) in ListaAnios" :key="index" :value="item">{{item}}</option>
                    </select>
				</div>
				<div class="form-group">
					<label for="">Mes</label>
					<select @change="Lista" name="" id="" class="ml-2 form-control" v-model="Filtro.Mes">
						<option value="">Todos</option>
						<option value="1">Enero</option>
						<option value="2">Febrero</option>
						<option value="3">Marzo</option>
						<option value="4">Abril</option>
						<option value="5">Mayo</option>
						<option value="6">Junio</option>
						<option value="7">Julio</option>
						<option value="8">Agosto</option>
						<option value="9">Septiembre</option>
						<option value="10">Octubre</option>
						<option value="11">Noviembre</option>
						<option value="12">Diciembre</option>
					</select>
				</div>
			</template>
			<template slot="header">
				<tr>
					<th>Cliente</th>
                	<th>Propiedad</th>
					<th>Fecha de Venta</th>
                	<th>Tipo de Servicio</th>
                	<th>SubTipo de Servicio</th>
					<th>Valor Venta</th>
					<th>Gross Profit</th>
					<!-- <th>Responsable</th> -->
                	<th>
						<span>Número de Contrato</span>
						<button class="btn btn-link" type="button" @click="CambiarOrdenContrato">
                            <i v-show="Filtro.OrdenContrato=='DESC'" class="fa fa-arrow-down text-white"></i>
                            <i v-show="Filtro.OrdenContrato=='ASC'" class="fa fa-arrow-up text-white"></i>
                        </button>
					</th>
					<th>Spend Plan</th>
                	<th>Acciones</th>
				</tr>
			</template>
			<template slot="body">
				<tr v-for="(item,key,index) in Ventas" :key="index">
					<td>{{item.Cliente}}</td>
                	<td v-b-tooltip.hover.top :title="item.Propiedad">{{$limitCharacters(item.Propiedad,30)}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaVenta,false)}}</td>
                	<td>{{GetTipoServicio(item.IdConfigS)}}</td>
                	<td>{{item.TipoServicio}}</td>
					<!-- <td>{{item.Usuario}}</td> -->
                	<td>$ {{Number( item.ValorVenta).toLocaleString("es-MX")}}</td>
					<td class="text-center">{{item.GrossProfit}} %</td>
                	<td v-b-tooltip.hover.top :title="item.NumeroC">{{$limitCharacters(item.NumeroC,40)}}</td>
					<td>
						<span v-if="item.FechaInicio!=null && item.FechaSpendPlan==null && item.SpendPlan=='2'">NO</span>
						<span v-if="item.FechaInicio==null">NO</span>
						<span v-if="item.FechaInicio!=null && (item.FechaSpendPlan!=null || item.SpendPlan=='1')">SI</span>
					</td>
					<td>
						<Cbtnaccion :isModal="EsModal" :IrA="FormName" :pEmitSeccion="EmitSeccion" :Id="item.IdVenta">
							<template slot="btnaccion">
								<button v-show="item.ArchivoBruto!=null && item.ArchivoBruto!=''" v-b-tooltip.hover.right title="Ver Archivo" class="btn-icon mr-2" @click="VerPdf(item.Archivo)"><i class="fa fa-file-pdf"></i></button>
								<button v-show="item.IdPropuesta>0" v-if="item.ArchivoBrutoPropuesta=='' || item.ArchivoBrutoPropuesta==null" v-b-tooltip.hover.right title="Ver Propuesta" class="btn-icon mr-2" @click="AbrirCotizacionCliente(item.IdCotizacionServicio)"><i class="fa fa-file-pdf"></i></button>
								<button v-show="item.IdPropuesta>0" v-else v-b-tooltip.hover.right title="Ver Propuesta" class="btn-icon mr-2" @click="VerPdf(item.ArchivoPropuesta)"><i class="fa fa-file-pdf"></i></button>
							</template>
						</Cbtnaccion>
					</td>
				</tr>
			</template>
		</Clist>
		<Modal :Showbutton="false" :size="size" :Nombre="NameList" :poBtnSave="oBtnSave" :pEmitSeccion="EmitSeccion" :NameModal="'ventas'">
        	<template slot="Form">
        	    <Form :poBtnSave="oBtnSave"></Form>
        	</template>
    	</Modal>
	</div>
</template>

<script>
import Clist from "@/components/Clist.vue";
import Modal from "@/components/Cmodal.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import CSinRegistros from "@/components/CSinRegistros.vue";
import Cbtnsave2 from "@/components/Cbtnsave2.vue";
import Form from "../ventas/Form.vue";
export default {
	name:'ventas',
    components:{
        Modal,
        Clist,
        Cbtnaccion,
        CSinRegistros,
        Form,
        Cbtnsave2
    },
	data() {
		return {
			EmitSeccion:'ventas',
			EsModal:true,
            size:'modal-xl',
			NameList:"Cierre de Ventas",
			FormName:'ventas',
			Pag:0,
            TotalPagina:2,
            Filtro:{
                Nombre:"",
                Placeholder:"Cliente / Propiedad / Contrato...",
                TotalItem:0,
                Pagina:1,
                Entrada:20,
				IdConfigS:'',
				IdTipoSer:'',
				Mes:'',
				OrdenContrato:'DESC',
				Anio:''
            },
			oBtnSave:{
                isModal:true,
                EmitSeccion:'ventas',
                nombreModal:'ventas',
                disableBtn:false,
                toast:0,
                ShowSave:false,
                ShowCancel:false
            },
			ConfigLoad:{
	    		ShowLoader:true,
	    		ClassLoad:true,
	    	},
			Ventas:[],
			ListaTipoSer:[],
			ListaAnios:[],
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader=true;
			await this.$http.get('ventas/get',{
				params:{
                    Nombre:this.Filtro.Nombre,
                    Entrada:this.Filtro.Entrada,
                    pag:this.Filtro.Pagina,
					IdConfigS:this.Filtro.IdConfigS,
					IdTipoSer:this.Filtro.IdTipoSer,
					Mes:this.Filtro.Mes,
					Anio:this.Filtro.Anio,
					OrdenContrato:this.Filtro.OrdenContrato
                }
			}).then((res)=>{
				this.Ventas=res.data.data.ventas;
                this.Filtro.Entrada=res.data.data.pagination.PageSize;
                this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
			}).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
		},
		Eliminar(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'ventas/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.Lista();
                    })
                }
            })
        },
		get_anios(){
			this.$http.get(
                'funciones/getanios',
                {
                    params:{}
                }
            ).then( (res) => {
              this.ListaAnios 	= res.data.ListaAnios;
              this.Filtro.Anio 		= res.data.AnioActual;
			  this.Lista();
            });
		},
		GetTipoPago(Numero){
			let Cadena='';
			switch (parseInt(Numero)) {
				case 1:
					Cadena="Anticipos";
					break;
				case 2:
					Cadena="Una Sola Exhibición";
					break;
			}
			return Cadena;
		},
		GetTipoServicio(Numero){
			let Cadena='';
			switch (parseInt(Numero)) {
				case 1:
					Cadena="Mantenimiento";
					break;
				case 2:
					Cadena="Servicio";
					break;
				case 3:
					Cadena="Proyecto";
					break;
			}
			return Cadena;
		},
		VerPdf(Nombre){
			let pdfWindow = window.open(Nombre);
            pdfWindow.document.write("<iframe width='100%' height='100%' src='" + Nombre +"'></iframe>");
		},
		AbrirCotizacionCliente(IdCotizacion){
			this.$http.get('reporte/cotizacioncliente',
            {
                responseType: 'blob',
                params :{
                        key:IdCotizacion,
                    }
            }).then( (response) => {
                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
            });
		},
		async GetTipoSer(){
			await this.$http.get('tiposervicio/get',{
				params:{
					RegEstatus:'A',
					IdConfigS:this.Filtro.IdConfigS,
					// IdTipoServ:this.contract.IdTipoServ,
					Entrada:''
				}
			}).then( (res) => {
				this.ListaTipoSer=res.data.data.tiposervicio;
			});
		},
		CambiarOrdenContrato(){
            if (this.Filtro.OrdenContrato=='DESC') {
                this.Filtro.OrdenContrato='ASC'
            }
            else{
                this.Filtro.OrdenContrato='DESC'
            }
            this.Lista();
        }
	},
	created(){
        this.bus.$off('Delete_'+this.EmitSeccion);
        this.bus.$off('List');
        this.bus.$off('Regresar');
		this.bus.$on('Regresar',()=>{
			this.$router.push({name:'submenuventas'});
		});
        this.get_anios();

        this.bus.$on('Delete_'+this.EmitSeccion,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List',()=>
        {
            this.Lista();
        });
    }
}
</script>

<style>

</style>
